export const titleBlock = `
_type == 'titleBlock' => {
  "title": title[_key == $lang][0].value,
}
`
